let revealObserver;

function initScrollReveal(root = document) {
  if (!revealObserver) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: '0px 0px -5% 0px'
      }
    );
  }

  root.querySelectorAll('main .shopify-section').forEach((section) => {
    section.classList.add('reveal-on-scroll');

    const heroItems = section.querySelectorAll(
      '.hero__content-wrapper .text-block, .hero__content-wrapper a[class*="button"]'
    );

    heroItems.forEach((item, index) => {
      item.classList.add('aop-reveal-item');
      item.style.setProperty('--reveal-delay', `${350 + index * 280}ms`);
    });

    revealObserver.observe(section);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
});

document.addEventListener('shopify:section:load', (event) => {
  initScrollReveal(event.target);
});